module.exports = __webpack_public_path__ + "img/bandaoti_juruixing_1.3f275907.png";